exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px) {.CartButton[data-v-bd4e2e46]:before {\n    content: '';\n\n    height: 0;\n\n    width: 100%;\n\n    --bg-opacity: 1;\n\n    background-color: #004876;\n\n    background-color: rgba(0, 72, 118, var(--bg-opacity));\n\n    position: absolute;\n\n    bottom: 0;\n\n    left: 0;\n\n    transition-property: all;\n\n    transition-duration: 200ms\n}\n}\n@media (min-width: 1024px) {\n.CartButton.active[data-v-bd4e2e46]:before {\n    height: 100%\n}\n}\n", ""]);

// exports
